<template>
  <Drop :drop="drop" :dragover="dragover" :dragleave="dragleave">
    <Darg
      :draggable="true"
      :dataSource="dragDataSource"
      @dragstart="dragstart(DragType.folder)"
      :dragRef="fileRef"
      :dragImage="dragImage[currentLayout]"
    >
      <div
        ref="fileRef"
        :class="[`folder-${currentLayout}`, hoverClass, checked ? 'is_checked' : '']"
      >
        <div class="operation">
          <div
            :class="['my-check-box', checked ? 'check-box-checked' : 'check-box-unckeck']"
            @click="changeChecked(checked)"
          ></div>
          <a-dropdown
            ><img class="operation_img" src="../../../../assets/more_operation.png" />
            <template #overlay>
              <ul class="dropdow_content">
                <EditFileModal
                  :modalId="`edit_modal_${columnKey}`"
                  :name="name"
                  ref="editFolderModalRef"
                  @submit="updateColumn"
                  rlogKey="all_folder_more_click_re"
                  title="重命名"
                  placeholder="请输入文件夹名称"
                >
                  <template v-slot:editImg>
                    <img
                      class="type-icon"
                      :src="
                        isNullFolder(dataSource)
                          ? require('../../imgs/folder.png')
                          : require('../../imgs/folder-content.png')
                      "
                    />
                  </template>
                  <li class="dropdow_item">重命名</li>
                </EditFileModal>
                <ConfirmModal
                  title="删除文件夹"
                  rlogKey="all_folder_more_click_delete"
                  contentTxt="是否要删除文件夹？删除后不可找回"
                  confirmBtnTxt="删除"
                  @confirm="handleDeleteOk"
                >
                  <li class="dropdow_item">删除</li>
                </ConfirmModal>
              </ul>
            </template>
          </a-dropdown>
        </div>
        <div class="folder_img">
          <img
            :src="
              isNullFolder(dataSource)
                ? require('../../imgs/folder.png')
                : require('../../imgs/folder-content.png')
            "
            @click="
              setParentNavList('push', parentColumnKey);
              changePage('/main/details', { key: columnKey });
            "
          />
        </div>

        <div
          class="folder_name"
          @click="
            changePage('/main/details', { key: columnKey });
            setParentNavList('push', parentColumnKey);
          "
        >
          {{ name }}
        </div>
      </div>
      <img src="../../imgs/drag_grid.png" :style="{ display: 'none' }" />
      <img src="../../imgs/drag_flow.png" :style="{ display: 'none' }" />
      <div v-if="showDragTipModal">
        <DragTipModal
          :dragTipsContent="dragTipsContent"
          @setShowDragTipModal="setShowDragTipModal"
        />
      </div>
    </Darg>
  </Drop>
</template>
<script setup>
import { ref, onMounted, defineEmits, defineProps } from 'vue';
import { message } from 'ant-design-vue';
import businessService from '@/services/business';
import routeController from '@/controller/router';
import Drop from '@/components/Drop/index.vue';
import ConfirmModal from '@/components/common/ConfirmModal.vue';
import EditFileModal from '@/components/common/EditFileModal.vue';
import DragTipModal from '../DragTipModal/index.vue';
import { isNullFolder } from '../../methods';
import storeController from '@/controller/store';
import checkIsOverSelectArea from '@/components/MouseSeleted/method';
import Darg from '@/components/Drag/index.vue';
import handleDrag, { dragImage, DragType } from '../method';
import handleDrop from './drop';

const props = defineProps({
  name: {
    type: String,
    require: true,
  },
  columnKey: {
    type: String,
    require: true,
  },
  parentColumnKey: {
    type: String,
    require: true,
  },
  checkFolderList: {
    type: Array,
    require: false,
  },
  checkFileList: {
    type: Array,
    require: false,
  },
  checkIrcList: {
    type: Array,
    require: false,
  },
  checked: {
    type: Boolean,
    require: false,
  },
  dataSource: {
    type: Object,
  },
  currentLayout: {
    type: String,
    default: 'grid',
  },
  articleList: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['initChoose', 'update', 'checkedFolderList', 'setParentNavList']);
function setParentNavList(...params) {
  emit('setParentNavList', ...params);
}

const fileRef = ref(null);
const editFolderModalRef = ref(null);
const {
  drop,
  hoverClass,
  dragover,
  dragleave,
  showDragTipModal,
  setShowDragTipModal,
  dragTipsContent,
} = handleDrop(props, emit);

const { dragstart, dragDataSource } = handleDrag(props, emit);
const { changePage } = routeController();
const changeChecked = (checked, isSet) => {
  emit(
    'checkedFolderList',
    { ...props.dataSource, id: props.columnKey, type: 'folder' },
    isSet ? checked : !checked
  );
};
const { getUserInfo } = storeController();
// 删除单曲弹窗
const handleDeleteOk = toggleModal => {
  const hideLoading = message.loading({ content: 'loading', duration: 0 });
  businessService
    .updateStatus({
      columnKey: props.columnKey,
      status: 2, // 0: 创建 1：发布 2：删除
    })
    .then(res => {
      hideLoading();
      if (res.code === 0) {
        getUserInfo();
        toggleModal(false);
        emit('update', 'folder', 'delete', props.columnKey);
      } else {
        message.error({ content: res.msg });
      }
    })
    .catch(e => {
      message.error({ content: e });
    });
};
// 修改专辑
const updateColumn = (value, callback) => {
  const hideLoading = message.loading({ content: 'loading', duration: 0 });
  businessService
    .update({
      columnKey: props.columnKey,
      title: value,
    })
    .then(res => {
      hideLoading();
      if (res.code === 0) {
        emit('update', 'folder');
        callback(false);
      } else {
        message.error({ content: res.msg });
      }
    })
    .catch(e => {
      message.error({ content: e });
    });
};

onMounted(() => {
  checkIsOverSelectArea(
    fileRef.value,
    isSelected => {
      if (props.checked !== isSelected) {
        changeChecked(isSelected, true);
      }
    },
    () => {
      // 点击空白区域取消选中
      changeChecked(false, true);
    },
    'folder'
  );
});
</script>

<style lang="scss" scoped>
.folder-flow.folder-hover,
.folder-grid.folder-hover,
.folder-grid:hover {
  background: $grey4;
  border-radius: 8px;
  .operation {
    visibility: visible;
  }
}
.folder-grid,
.folder-flow {
  margin-bottom: 10px;
}
.folder-grid {
  width: 160px;
  height: 160px;
  cursor: pointer;
  position: relative;
  padding-top: 20px;
  box-sizing: border-box;
  text-align: center;
  .folder_img {
    width: 80px;
    height: 80px;
    text-align: center;
    margin: 0 auto;
    img {
      width: 80px;
      height: 67px;
      user-select: none;
      margin-top: 7px;
      -webkit-user-drag: none;
    }
  }
  .folder_name {
    word-wrap: break-word;
    word-break: break-all;
    padding: 0 10px;
    margin-top: 10px;
    font-weight: 500;
    line-height: 16px;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .operation {
    visibility: hidden;
    padding: 10px 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    .operation_img {
      width: 20px;
    }
  }
}
.is_checked {
  background: $grey4;
  border-radius: 8px;
  .operation {
    visibility: visible;
  }
}
.dropdow_content {
  background: rgba(0, 0, 0, 0.8);
  width: 140px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  .dropdow_item {
    cursor: pointer;
    padding-left: 20px;
    color: #fff;
    font-size: 15px;
    line-height: 50px;
    height: 50px;
    width: 140px;
  }
}
::v-deep(.ant-checkbox-inner) {
  width: 20px;
  height: 20px;
}
</style>
